import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          email: Yup.string()
                                                    .email('Must be a valid email'),
                                          url: Yup.string()
                                                  .url('Must be a valid URL'),
                                      });
